import { createContext, useContext } from "react";
import type { AdvisorData } from "@/mocks/advisors";
import { defaultAdvisor } from "@/mocks/advisors";

const AdvisorContext = createContext<AdvisorData>(defaultAdvisor);

export function AdvisorProvider({
  advisor,
  children,
}: {
  advisor: AdvisorData;
  children: React.ReactNode;
}) {
  return (
    <AdvisorContext.Provider value={advisor}>
      {children}
    </AdvisorContext.Provider>
  );
}

export function useAdvisor(): AdvisorData {
  return useContext(AdvisorContext);
}